import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AvantoRoutingService } from 'src/app/services/avanto-routing.service';
import { AvantoSessionService } from 'src/app/services/avanto-session.service';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { AvantoLambdaService } from 'src/app/services/avanto-lambda.service';
import Swal from 'sweetalert2';
import { finalize } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-order-complete-page',
  templateUrl: './order-complete-page.component.html',
  styleUrls: ['./order-complete-page.component.scss'],
  animations: [
    trigger('animateStars', [
      state('starsBig', style({
        'font-size': '5rem',
      })),
      state('starsSmall', style({
        'font-size': '2rem',
      })),
      transition('starsBig => starsSmall', [
        animate('0.5s')
      ]),
    ])
  ]
})
export class OrderCompletePageComponent implements OnInit {

  sessionObserver: Subscription;
  isOneRestaurantMode:boolean;
  showPickupOnly:boolean
  selectedRestaurantId:string;
  selectedRestaurantTitle:string;

  isLoadingContent:boolean;
  isSubmittingFeedback:boolean;
  showInputTextArea:boolean;
  feedbackSubmitted:boolean;
  selectedRating: number;
  googleReviewLink:string;
  userFeedback:string;

  constructor(private avantoSession: AvantoSessionService, private avantoRoute: AvantoRoutingService, private lambda: AvantoLambdaService, private route: ActivatedRoute) { }

  ngOnInit() {
    this.isLoadingContent = true;
    this.feedbackSubmitted = false;
    this.showInputTextArea = false;
    this.isSubmittingFeedback = false;

    this.sessionObserver = this.avantoSession.sessionSubject.subscribe(session => {
      if (session != null) {

        this.isOneRestaurantMode = session.isOneRestaurantMode;
        if(session.restaurantInformation!=null){
          if(this.isOneRestaurantMode){
            this.showPickupOnly = session.restaurantInformation.hasPickup && !session.restaurantInformation.hasDelivery;
            this.selectedRestaurantId = session.restaurantInformation.restaurantId
            this.selectedRestaurantTitle = session.restaurantInformation.title;
          }


          let routeSplit = this.route.snapshot.params['orderStatus'].split('-');
          if(routeSplit.length>1){
            //The user can see the LEAVE US A REVIEW content
            if(routeSplit[1] == "LEAVE_US_A_REVIEW"){
              if(session.restaurantInformation.googleReviewLink!=null){
                //If the googleReviewLink is present, the LEAVE US A REVIEW content will be displayed
                this.googleReviewLink = session.restaurantInformation.googleReviewLink;
              }
            }
          }
        }

        this.isLoadingContent = false;
      }
    })
  }

  backToInitialPageClicked() {
    if(this.isOneRestaurantMode==false){
      this.avantoRoute.goToInitialPage();
    }else{
      const restaurantIdSplit = this.selectedRestaurantId.split(".")
      this.avantoRoute.goToOneRestaurantModeChooseFoodPage(restaurantIdSplit[0],restaurantIdSplit[1])
    }
  }


  /**
   * Called when the customer clicks a rating star
   * @param number star clicked: 1 = 1 star, 2 = 2 stars...
   */
  selectStarRating(number){
    if(!this.feedbackSubmitted){
      this.feedbackSubmitted = true;
      this.selectedRating = number;
      if(number < 4){
        this.showInputTextArea = true;
      }else{
        window.open(this.googleReviewLink);
      }
    }
  }

  /**
   * Saves the feedback given by the customer
   * @param string feedback text
   */
  submitFeedback(){
    if(this.userFeedback == null || this.userFeedback == ""){
      Swal.fire("Could not submit feedback","Please make sure all required fields have been set.")
      return;
    }

    this.isSubmittingFeedback = true;
    this.lambda.sendReviewEmail(this.userFeedback, this.selectedRestaurantId, this.selectedRestaurantTitle)
      .pipe(finalize(()=>{
        this.isSubmittingFeedback = false;
        this.showInputTextArea = false;
        this.feedbackSubmitted = true;
      }))
      .subscribe((result:any) => {
      const receivedData = JSON.parse(result._body).data
      console.log(receivedData)
    }, error => {
      console.error("Could not send review e-mail: ",error)
    });
  }
}